import React from "react";
import PropTypes from "prop-types";
import { SlideBlockContext } from "../SlideBlock";
import style from "./style.module.scss";

/*
 * Description:
 *	- Component that display the description for design section
 */
export function Description({ descriptions }) {
  const { getTabIndex } = React.useContext(SlideBlockContext);

  return descriptions.map((description) => (
    <p tabIndex={getTabIndex()} className={style.designView_left_description}>
      {description}
    </p>
  ));
}

Description.propTypes = {
  /*
   * Description string for design section
   */
  descriptions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

Description.defaultProps = {
  descriptions: [],
};
